export const DCA_CODES = ["PreDCA-New", "PreDCA-Recall"]

export const ASSIGN_ERROR_CODE = "ASSIGNERROR"
